// extracted by mini-css-extract-plugin
export default {"lazyVideoSpinner":"_2a8b6663"};